import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { SharedService } from "./sharedService";
import { map } from "rxjs/operators";
const httpOptions = {
  headers: new HttpHeaders({ "Content-Type": "application/json" }),
};
@Injectable({
  providedIn: "root",
})

export class CategoryService {
  constructor(public http: HttpClient, public sharedService: SharedService) { }

  getList(resourceUrl: string, potentialParents = null): Observable<any> {
    if (potentialParents) {
      return this.http
        .get(this.sharedService.apiUrl(resourceUrl) + "/potentialParents/" + potentialParents)
        .pipe(
          map((res) => {
            return res;
          })
        );
    } else {
      return this.http.get(this.sharedService.apiUrl(resourceUrl)).pipe(
        map((res) => {
          return res;
        })
      );
    }
  }

  addEntity(ent): Observable<any> {
    return this.http.post<any>(this.sharedService.apiUrl('dictionary/'), ent, httpOptions).pipe(
      map((res) => {
        return res;
      })
    );
  }

    deleteEntity(resourceUrl, id): Observable<any> {
    return this.http.delete<any>(this.sharedService.apiUrl(resourceUrl+'/'+id), httpOptions).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getSubList(resourceUrl: string): Observable<any> {
    return this.http.get(this.sharedService.apiUrl(resourceUrl)).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getCategory(resourceUrl: string, id: string): Observable<any> {
    return this.http
      .get(this.sharedService.apiUrl(resourceUrl) + "/" + id)
      .pipe(
        map((res) => {
          return res;
        })
      );
  }
  getParentByChild(resourceUrl: string, id: string): Observable<any> {
    return this.http
      .get(this.sharedService.apiUrl(resourceUrl) + "/child/" + id)
      .pipe(
        map((res) => {
          return res;
        })
      );
  }
}
